import React from 'react';
import './StaticOverlay.css';
import staticImg from './assets/static.gif.webp';

/**
 * A white-noise overlay that fades in/out.
 * Visibility is controlled by the `show` prop.
 */
const StaticOverlay = ({ show }) => (
  <div className={`static-overlay ${show ? 'show' : ''}`}>
    <img className='static' src={staticImg} alt="" />
  </div>
);

export default StaticOverlay;
